import {
	Carrier,
	CostCodes as CostCodesModule,
	Modal as ModalModule,
} from 'common';
import React, { useState } from 'react';
import ContactInfo from '../contactInfo/ContactInfo.component';
import PaymentSettings from '../payment/PaymentSettings.component';
import ShipFromAddress from '../shipFromAddress/ShipFromAddress.component';
import Users from '../users/Users.component';
import LocationGeneralSettings from './LocationGeneralSettings.component';
import { SettingsLeftMenuView } from './SettingsLeftMenuView.component';

const { ManageCarrier } = Carrier;
const { Modal } = ModalModule;
const { CostCodes } = CostCodesModule;

const LocationSettingsModal = ({ data, modalId }) => {
	const {
		callback,
		regions,
		singleLocation,
		userCorpInfo,
		MAXIMUM_LIMIT_AMOUNT,
	} = data;
	const [settingsViewToken, setSettingsViewToken] = useState(0);
	const onMenuItemClick = navigationToken => {
		localStorage.removeItem('selectedEnterpriseLocation');
		setSettingsViewToken(navigationToken);
	};
	let settingsView;

	// Server is sending ConfiguredCarriers, but the component is expecting configuredCarriers
	if (singleLocation.hasOwnProperty('ConfiguredCarriers')) {
		singleLocation.configuredCarriers = singleLocation.ConfiguredCarriers;
		delete singleLocation.CongiguredCarriers;
	}

	switch (settingsViewToken) {
		case 'manageUsers':
			settingsView = <Users enterpriseLocation={singleLocation} />;
			break;
		case 'shipFromAddress':
			settingsView = <ShipFromAddress enterpriseLocation={singleLocation} />;
			break;
		case 'costCodes':
			settingsView = <CostCodes enterpriseLocation={singleLocation} />;
			break;
		case 'defaultPayment':
			settingsView = <PaymentSettings enterpriseLocation={singleLocation} />;
			break;
		case 'contactInformation':
			settingsView = <ContactInfo enterpriseLocation={singleLocation} />;
			break;
		case 'carrierSettings':
			settingsView = (
				<ManageCarrier
					enterpriseLocation={singleLocation}
					callback={callback}
				/>
			);
			break;
		default:
			// defaults to generalSettings
			settingsView = (
				<LocationGeneralSettings
					enterpriseLocation={singleLocation}
					regions={regions}
					callback={callback}
					userCorpInfo={userCorpInfo}
					MAXIMUM_LIMIT_AMOUNT={MAXIMUM_LIMIT_AMOUNT}
				/>
			);
	}

	return (
		<Modal
			modalId={modalId}
			className="account-locations location-settings-modal"
			header={`${singleLocation.MeterAccount.Name} Settings`}
			hideFooter
		>
			<div className="settings-menu">
				<SettingsLeftMenuView settingsModalCallback={onMenuItemClick} />
			</div>
			<div className="settings-content">{settingsView}</div>
		</Modal>
	);
};

export default LocationSettingsModal;
